(function () {
  var TEXT_MAP = {
    '15%': 'KUP 2, OTRZYMASZ 15% ZNIŻKI',
    '20%': 'KUP 3, OTRZYMASZ 20% ZNIŻKI',
    '25%': 'KUP 4, OTRZYMASZ 25% ZNIŻKI'
  };

  function updateBadges() {
    document.querySelectorAll('.kaching-cart__cart-discounts-badge span').forEach(function (span) {
      var current = span.textContent.trim();
      var newText = TEXT_MAP[current];
      if (newText && span.textContent !== newText) {
        span.textContent = newText;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadges);
  } else {
    updateBadges();
  }

  var observer = new MutationObserver(function () {
    updateBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();